import AgencyHelper from "features/Agency/agencyHelper";
import ReconciliationReportHelper from "features/ReconciliationReport/ReconciliationReportHelper";
import KTBSButton, { KTBSButtonColor, KTBSButtonSize } from "general/components/OtherKeenComponents/KTBSButton";
import KTLabel, { KTLabelSize } from "general/components/OtherKeenComponents/KTLabel";
import CustomCard from "general/components/Others/CustomCard";
import VITableRowDropDown from "general/components/VITableRowDropDown";
import AppColors from "general/constants/AppColors";
import Utils from "general/utils/Utils";
import useRouter from "hooks/useRouter";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { AppCustomDialogHelper } from "general/components/AppDialogCustom";
import BreadcrumbHelper from "general/components/CustomBreadcrumb/BreadcrumbHelper";
import ToastHelper from "general/helpers/ToastHelper";
import UIHelper from "general/helpers/UIHelper";
import _ from "lodash";
import AppConstants from "general/constants/AppConstants";
import DialogEditReconciliationView from "features/ReconciliationReport/SaleReconciliationReport/components/DialogEditReconciliationView";
import AgencyReconciliationCardView from "features/ReconciliationReport/SaleReconciliationReport/components/AgencyReconciliationCardView";
import tableStyle from "general/components/OtherKeenComponents/KTTable/tableStyle";
import KTTable from "general/components/OtherKeenComponents/KTTable";
import EmptyView from "general/components/Others/EmptyView";
import imgEmptyNoData from 'assets/images/img_emptyview_no_data.png';
import AppRoute from "general/constants/AppRoute";
import KTPagination, { KTPaginationColor } from "general/components/OtherKeenComponents/KTPagination";
import KTTooltip from "general/components/OtherKeenComponents/KTTooltip";

GroupReconciliationDetailView.propTypes = {};

function GroupReconciliationDetailView(props) {
    // MARK: ---- PROPERTIES ----
    const router = useRouter();
    const { t } = useTranslation();
    const { reconciliationId } = router.query;
    const agencyId = router?.query?.agencyId;
    const [reconciliationDetail, setReconciliationDetail] = useState(null);
    const [agencyDetail, setAgencyDetail] = useState(null);
    const [groupInvestmentList, setGroupInvestmentList] = useState(null);
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(10);
    const { user } = useSelector((state) => state.auth);
    const adminRole =
        user?.role === AppConstants.userRole.admin || user?.role === AppConstants.userRole.operator;
    const isOrganizationAgency = useMemo(() => {
        return reconciliationDetail?.agency?.type === 'ORGANIZATION';
    }, [reconciliationDetail]);

    const columns = [
        {
            name: UIHelper.buildTableColumn('NĐT liên kết'),
            selector: (row) => (
                <div
                    onClick={() => {
                        Utils.openInNewTab(`${AppRoute.groupList}/${row?.agency?.agencyId}`);
                    }}
                >
                    {row?.agency?.name}
                </div>
            ),
            minWidth: '300px',
            style: tableStyle.columns.link,
        },
        {
            name: UIHelper.buildTableColumn('Số tiền đầu tư', 'VNĐ'),
            selector: (row) => Utils.formatNumber(Math.round(row?.amount ?? 0)),
            minWidth: '200px',
            style: tableStyle.columns.normal,
            right: true,
        },
        {
            name: UIHelper.buildTableColumn('Tỷ lệ NĐT được hưởng', '%'),
            selector: (row) => Utils.formatNumber((row?.share * 100)?.toFixed(3)),
            minWidth: '200px',
            right: true,
            style: tableStyle.columns.normal,
        },
        {
            name: UIHelper.buildTableColumn('Ngày đầu tư'),
            selector: (row) => Utils.formatDateTimeToString(row?.validFrom, 'DD/MM/YYYY'),
            minWidth: '200px',
            style: tableStyle.columns.normal,
        },
        {
            name: UIHelper.buildTableColumn('Ngày hưởng doanh thu'),
            selector: (row) => {
                if (!row?.validFrom) return '';
                const date = new Date(row.validFrom);
                if (isNaN(date)) return '';
                date.setMonth(date.getMonth() + 1, 1);
                return Utils.formatDateTimeToString(date, 'DD/MM/YYYY');
            },
            minWidth: '200px',
            style: tableStyle.columns.normal,
        },
    ];

    useEffect(() => {
        handleGetGroupReconciliationDetail();
    }, [reconciliationId, agencyId]);

    const handleGetGroupReconciliationDetail = () => {
        if (reconciliationId) {
            AgencyHelper.API.requestGetReconciliationDetail(reconciliationId).then(
                (reconciliationDetail) => {
                    setReconciliationDetail(reconciliationDetail);
                    setAgencyDetail(reconciliationDetail?.agency);
                    setGroupInvestmentList(reconciliationDetail?.metadata?.groupShare?.investments);
                }
            );
        } else if (agencyId) {
            const paramGetReconciliationList = {
                agencyId,
            };
            AgencyHelper.API.requestGetReconciliationList(paramGetReconciliationList).then(
                (reconciliationList) => {
                    setReconciliationDetail(_.maxBy(reconciliationList, 'reconciliationId'));
                }
            );
        }
    }

    const SaleReconciliationInfo = () => {
        return (
            <div
                className="row m-0 position-relative p-3 bg-white rounded-lg"
                style={{
                    border: `1px solid ${AppColors.gray[300]}`,
                    boxShadow: '0px 7px 8px -3px #0000000D',
                }}
            >
                <div className="d-flex align-items-center w-100 p-0">
                    <div className="d-flex flex-column w-100">
                        <div className="d-flex align-items-center gap-2" style={{ overflow: 'hidden' }}>
                            <div
                                className="font-weight-bolder"
                                style={{
                                    color: AppColors.gray[800],
                                    fontSize: Utils.returnFontSize(18),
                                    fontWeight: '600',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                }}
                            >
                                {agencyDetail?.name}{" "}
                                • {agencyDetail?.agencyCode ?? agencyDetail?.agencyId}
                            </div>

                            <span className="min-w-100px ml-3">
                                <KTLabel
                                    text={ReconciliationReportHelper.getReconciliationStatusName(reconciliationDetail?.status)}
                                    isInline={true}
                                    size={KTLabelSize.medium}
                                    additionalClassName={`label-light-${ReconciliationReportHelper.getReconciliationStatusColor(
                                        reconciliationDetail?.status
                                    )}`}
                                />
                            </span>
                        </div>
                        <div style={{ fontSize: Utils.returnFontSize(14), color: AppColors.gray[700] }}>
                            Đối soát doanh thu NĐT liên kết {Utils.formatDateTimeToString(reconciliationDetail?.month, 'MM/yyyy')}
                        </div>
                    </div>

                    <div className="d-flex gap-3">
                        {!adminRole && reconciliationDetail?.status === 'ADMIN_SIGNED' &&
                            <KTBSButton
                                color={KTBSButtonColor.success}
                                title={t('Ký đối soát')}
                                size={KTBSButtonSize.default}
                                borderRadius={5}
                                buttonTitleFontWeight="600"
                                onPress={() => ReconciliationReportHelper.handleAgencySignReconciliation(reconciliationDetail, handleGetGroupReconciliationDetail)}
                                height={43}
                                buttonTitleFontSize={14}
                            />
                        }
                        {adminRole && reconciliationDetail?.status === 'CREATED' &&
                            <KTBSButton
                                color={KTBSButtonColor.success}
                                title={t('Duyệt & ký đối soát')}
                                size={KTBSButtonSize.default}
                                borderRadius={5}
                                buttonTitleFontWeight="600"
                                onPress={() => ReconciliationReportHelper.handleAdminSignReconciliation(reconciliationDetail, handleGetGroupReconciliationDetail)}
                                height={43}
                                buttonTitleFontSize={14}
                            />
                        }
                        <VITableRowDropDown
                            toggleElement={
                                <a
                                    href="#"
                                    className="btn btn-sm btn-clean btn-icon h-45px w-45px hover-opacity-60"
                                    style={{ backgroundColor: AppColors.gray[200] }}
                                    onClick={(e) => {
                                        e.preventDefault();
                                    }}
                                >
                                    <i
                                        className="fa-solid fa-ellipsis"
                                        style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                                    />
                                </a>
                            }
                            menuItem={[
                                {
                                    iconElement: <i className="fa-regular fa-pen-to-square"></i>,
                                    text: t('edit'),
                                    click: () => {
                                        AppCustomDialogHelper.show(
                                            `Sửa đối soát tháng ${Utils.formatDateTimeToString(reconciliationDetail?.month, 'MM/YYYY')}`,
                                            <DialogEditReconciliationView
                                                item={reconciliationDetail}
                                                onCancel={() => {
                                                    AppCustomDialogHelper.hide();
                                                }}
                                                onDone={() => {
                                                    ToastHelper.showSuccess('Cập nhật đối soát thành công!')
                                                    AppCustomDialogHelper.hide();
                                                    handleGetGroupReconciliationDetail();
                                                }}
                                            />,
                                            'md',
                                            true,
                                            true
                                        )
                                    },
                                    show: adminRole && (reconciliationDetail?.reconciliationType === 'PAPER' && reconciliationDetail?.status === 'COMPLETED'),
                                },
                                // {
                                //     iconElement: <i className="fa-regular fa-memo-circle-info"></i>,
                                //     text: 'Đơn hàng liên quan',
                                //     click: () => {
                                //         if (!adminRole) {
                                //             router.navigate(`/order?month=${reconciliationDetail?.month}`);
                                //         } else {
                                //             router.navigate(`/order?agencyId=${reconciliationDetail?.agency?.agencyId}&month=${reconciliationDetail?.month}`);
                                //         }
                                //     },
                                //     show: true,
                                // },
                                {
                                    iconElement: <i className="fa-regular fa-file-chart-column"></i>,
                                    text: t('Xem file đối soát'),
                                    click: () => {
                                        if (Utils.isValid(reconciliationDetail?.document)) {
                                            Utils.openInNewTab(Utils.getFullUrl(reconciliationDetail?.document));
                                        }
                                    },
                                    show: !!reconciliationDetail?.document,

                                },
                                {
                                    iconElement: <i className="far fa-download"></i>,
                                    text: t('Tải đối soát excel'),
                                    click: () => Utils.openInCurrentTab(reconciliationDetail?.documentXLSX),
                                    show: !!reconciliationDetail?.documentXLSX,

                                },
                                {
                                    iconElement: <i className="far fa-message-exclamation"></i>,
                                    text: 'Gửi phản hồi',
                                    click: () => ReconciliationReportHelper.showDialogReconciliationFeedback(reconciliationDetail, adminRole, handleGetGroupReconciliationDetail),
                                    show: !adminRole && reconciliationDetail?.status !== 'AGENCY_SIGNED',
                                },
                                {
                                    iconElement: <i className="far fa-message-exclamation"></i>,
                                    text: 'Xem phản hồi',
                                    click: () => ReconciliationReportHelper.showDialogReconciliationFeedback(reconciliationDetail, adminRole, handleGetGroupReconciliationDetail),
                                    show: adminRole && !!reconciliationDetail?.feedback,
                                },
                                {
                                    iconElement: <i className="far fa-file-check"></i>,
                                    text: 'Duyệt hóa đơn thuế',
                                    click: () => ReconciliationReportHelper.showDialogApprovalInvoice(reconciliationDetail, adminRole, handleGetGroupReconciliationDetail),
                                    show: adminRole && reconciliationDetail?.agency?.type === 'ORGANIZATION' && reconciliationDetail?.status === 'AGENCY_SIGNED' && !!reconciliationDetail?.attachedFiles?.length,
                                },
                                {
                                    iconElement: <i className="far fa-upload"></i>,
                                    text: 'Tải lên hóa đơn thuế',
                                    click: () => ReconciliationReportHelper.showDialogUploadInvoiceDocument(reconciliationDetail, handleGetGroupReconciliationDetail),
                                    show: reconciliationDetail?.agency?.type === 'ORGANIZATION' && reconciliationDetail?.status === 'AGENCY_SIGNED',
                                },
                            ]}
                            singleBtnBgColor={AppColors.gray[200]}
                        />
                    </div>
                </div>
            </div>
        );
    };

    const groupCommissionList = useMemo(() => {
        const { metadata } = reconciliationDetail || {};
        const { yourInvestments = [], groupShare = {} } = metadata || {};
        const totalInvestmentAmount = yourInvestments.reduce((sum, { amount = 0 }) => sum + amount, 0);
        const { totalAssets = 0 } = groupShare;
        const investmentRate = totalAssets ? (totalInvestmentAmount / totalAssets) * 100 : 0;

        return [
            {
                name: 'Tổng số vốn góp của dự án',
                value: Number(Math.round(totalAssets)),
                unit: 'VNĐ',
                color: '#E6196E',
                icon: 'fa-solid fa-users',
                descriptionValue: '1',
                additionalDes: (
                    <KTTooltip
                        text={`<div>Chỉ hiển thị với Nhà điều hành. Nhà đầu tư không xem được tổng số vốn góp của dự án</div>`}
                        textHeader="Tổng số vốn góp của dự án"
                        isHtmlContent
                    >
                        <i
                            className="fa-regular fa-info-circle"
                            style={{ color: AppColors.primary }}
                        />
                    </KTTooltip>
                ),
                show: adminRole,
            },
            {
                name: 'Số tiền NĐT đã đầu tư',
                value: Number(Math.round(totalInvestmentAmount)),
                unit: 'VNĐ',
                color: '#FE6358',
                icon: 'fa-solid fa-sack-dollar',
                descriptionValue: !adminRole ? '1' : '2',
                show: true,
            },
            {
                name: 'Tỷ lệ vốn góp của NĐT',
                value: Number(investmentRate.toFixed(3)),
                unit: '%',
                color: '#FFAA24',
                icon: 'fa-solid fa-badge-percent',
                descriptionValue: !adminRole ? '2' : '3=2/1',
                show: true,
            }
        ];
    }, [reconciliationDetail, adminRole]);

    const GroupCommissionReconciliationInfo = () => {
        return (
            <div
                className="overflow-hidden position-relative mt-4"
                style={{
                    border: `1px solid ${AppColors.gray[300]}`,
                    borderRadius: '10px',
                }}
            >
                <div
                    style={{
                        backgroundColor: '#fff',
                        borderBottomLeftRadius: '10px',
                        borderBottomRightRadius: '10px',
                    }}
                >
                    {/* barchart */}
                    <div className="w-100 d-flex flex-column gap-1 p-4"
                        style={{
                            borderBottom: `1px solid ${AppColors.gray[300]}`
                        }}
                    >
                        <div style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[800])}>
                            Tỷ lệ NĐT được hưởng
                        </div>
                    </div>
                    {/* body */}
                    <div className="w-100 d-flex p-4 gap-3">
                        {groupCommissionList?.filter(cardInfo => cardInfo?.show)
                            ?.map((cardInfo, index) => (
                                <div
                                    key={index}
                                    className="flex-grow-1 p-0"
                                >
                                    <AgencyReconciliationCardView
                                        name={cardInfo.name}
                                        value={cardInfo.value}
                                        unit={cardInfo.unit}
                                        color={cardInfo.color}
                                        icon={cardInfo.icon}
                                        descriptionValue={cardInfo.descriptionValue}
                                        additionalDes={cardInfo?.additionalDes}
                                    />
                                </div>
                            ))}
                    </div>
                </div>
            </div >
        )
    }
    const groupRevenueList = useMemo(() => {
        const { metadata, taxRate = 0 } = reconciliationDetail || {};
        const { groupEnergy = {}, yourInvestments = [], groupShare = {} } = metadata || {};
        const { totalEnergyByVehicleType = [] } = groupEnergy || {};
        const { totalAssets = 0 } = groupShare;

        const totalInvestmentAmount = yourInvestments.reduce((sum, { amount = 0 }) => sum + amount, 0);
        const investmentRate = totalAssets ? totalInvestmentAmount / totalAssets : 0;

        const getEnergyByVehicleType = (vehicleType) =>
            _.sumBy(
                reconciliationDetail?.metadata?.groupEnergy?.totalEnergyByVehicleType?.filter(item => item.vehicleType === vehicleType),
                'totalEnergy'
            ) ?? 0;

        const carEnergy = getEnergyByVehicleType('CAR') / 1000;
        const bikeEnergy = getEnergyByVehicleType('BIKE') / 1000;
        const revenueBeforeTax = Math.round(reconciliationDetail?.amount);
        const personalIncomeTax = Math.round(revenueBeforeTax * reconciliationDetail?.taxRate);
        const revenueAfterTax = !isOrganizationAgency ? Math.round(revenueBeforeTax - personalIncomeTax) : revenueBeforeTax;

        return [
            {
                name: 'Sản lượng điện sạc ô tô',
                value: Number(carEnergy?.toFixed(3)),
                unit: 'kWh',
                descriptionValue: !adminRole ? '3' : '4',
            },
            {
                name: 'Sản lượng điện sạc xe máy',
                value: Number(bikeEnergy?.toFixed(3)),
                unit: 'kWh',
                descriptionValue: !adminRole ? '4' : '5',
            },
            {
                name: 'Doanh thu theo phương tiện',
                value: Number(revenueBeforeTax),
                unit: 'VNĐ',
                descriptionValue: !adminRole ? '5=2*(3*1500+4*1000)' : '6=3*(4*1500+5*1000)'
            },
            {
                name: `Thuế TNCN ${Number((taxRate * 100).toFixed(3))}%`,
                value: Number(personalIncomeTax),
                unit: 'VNĐ',
                descriptionValue: !adminRole ? '6=5*10%' : '7=6*10%',
                show: !isOrganizationAgency,
            },
            {
                name: 'Doanh thu NĐT được nhận',
                value: Number(reconciliationDetail?.netAmount),
                valueColor: AppColors.primary,
                unit: 'VNĐ',
                unitColor: AppColors.primary,
                descriptionValue: !adminRole ? '7=5-6' : '8=6-7',
            }
        ];
    }, [reconciliationDetail, adminRole, isOrganizationAgency]);

    const GroupRevenueReconciliationInfo = () => {
        return (
            <div
                className="overflow-hidden position-relative mt-4"
                style={{
                    border: `1px solid ${AppColors.gray[300]}`,
                    borderRadius: '10px',
                }}
            >
                <div
                    style={{
                        backgroundColor: '#fff',
                        borderBottomLeftRadius: '10px',
                        borderBottomRightRadius: '10px',
                    }}
                >
                    <div className="w-100 d-flex flex-column gap-1 p-4"
                        style={{
                            borderBottom: `1px solid ${AppColors.gray[300]}`
                        }}
                    >
                        <div style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[800])}>
                            Doanh thu NĐT được nhận
                        </div>
                    </div>
                    {/* body */}
                    <div className="w-100 d-flex">
                        {groupRevenueList?.filter(card => card?.show !== false)
                            ?.map((cardInfo, index) => (
                                <div
                                    key={index}
                                    className="flex-grow-1 p-0"
                                    style={{ borderRight: index < groupRevenueList.length - 1 ? `1px solid ${AppColors.gray[300]}` : 'none' }}
                                >
                                    <AgencyReconciliationCardView
                                        name={cardInfo.name}
                                        value={cardInfo.value}
                                        valueColor={cardInfo.valueColor}
                                        unit={cardInfo.unit}
                                        unitColor={cardInfo.unitColor}
                                        descriptionValue={cardInfo.descriptionValue}
                                        showBorder={false}
                                    />
                                </div>
                            ))}
                    </div>
                </div>
            </div >
        )
    }

    const groupInvestmentListInfo = useMemo(() => {
        if (!adminRole || !groupInvestmentList?.length) return;

        const total = groupInvestmentList.length;
        const paginatedItems = groupInvestmentList.slice(page * limit, (page + 1) * limit);

        return (
            <div
                className="overflow-hidden position-relative mt-4 w-100"
                style={{
                    border: `1px solid ${AppColors.gray[300]}`,
                    borderRadius: '10px',
                }}
            >
                <div
                    style={{
                        backgroundColor: '#fff',
                        borderBottomLeftRadius: '10px',
                        borderBottomRightRadius: '10px',
                        width: '100%',
                    }}
                >
                    <div
                        className="w-100 d-flex align-items-center gap-1 p-4"
                        style={{
                            borderBottom: `1px solid ${AppColors.gray[300]}`,
                        }}
                    >
                        <div style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[800])}>
                            Danh sách đầu tư tham gia dự án
                        </div>
                        <KTTooltip
                            text={`<div>Chỉ hiển thị với Nhà điều hành. Nhà đầu tư không xem được danh sách đầu tư tham gia dự án</div>`}
                            textHeader="Danh sách nhà đầu tư tham gia dự án"
                            isHtmlContent
                        >
                            <i
                                className="fa-regular fa-info-circle"
                                style={{ color: AppColors.primary }}
                            />
                        </KTTooltip>
                    </div>
                    {/* body */}
                    <div className="p-4">
                        <KTTable
                            columns={columns}
                            items={paginatedItems}
                            selectableRows={false}
                            striped={false}
                            compactGrid={false}
                            onClickedRow={() => { }}
                            onSelectedRowsChanged={() => { }}
                            onDoubleClickedRow={() => { }}
                            hasActionColumn={false}
                            noDataComponent={
                                <EmptyView
                                    icon={imgEmptyNoData}
                                    title="Không có dữ liệu để hiển thị"
                                    text={<span>Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.</span>}
                                />
                            }
                        />
                    </div>

                    {/* phan trang */}
                    <div className="pb-4 px-4">
                        <KTPagination
                            currentPage={page + 1}
                            rowCount={total}
                            rowsPerPage={limit}
                            currentItemInPageCount={paginatedItems.length}
                            onChangePage={(newPage) => {
                                const iNewPage = parseInt(newPage);
                                setPage(iNewPage - 1);
                            }}
                            onChangeRowsPerPage={(newRowsPerPage) => {
                                const iNewRowsPerPage = parseInt(newRowsPerPage);
                                setLimit(iNewRowsPerPage);
                                setPage(0);
                            }}
                            color={KTPaginationColor.success}
                            appendText="NĐT"
                        />
                    </div>
                </div>
            </div>
        );
    }, [groupInvestmentList, page, limit, adminRole])

    return (
        <div>
            <div className="w-100">
                {BreadcrumbHelper.buildBreadcrumb([
                    {
                        title: 'Báo cáo đối soát NĐT HTKD',
                        onPress: () => {
                            router.navigate(-1);
                        },
                    },
                    { title: 'Chi tiết báo cáo đối soát' },
                ])}
            </div>

            <div className="m-4 mt-16">
                {/* thong tin Dai ly */}
                <CustomCard
                    showHeader={false}
                    additionalClassName="rounded-lg overflow-hidden"
                    bgTransparent={true}
                    showBorder={false}
                    body={
                        <div className="d-flex flex-column">
                            <div
                                className={`col-12 p-0 h-100`}
                            >
                                <SaleReconciliationInfo />

                                <GroupCommissionReconciliationInfo />

                                <GroupRevenueReconciliationInfo />

                                <div>{groupInvestmentListInfo}</div>
                            </div>

                        </div>
                    }
                />


            </div>
        </div>
    );
}

export default GroupReconciliationDetailView;
